module.exports = __webpack_public_path__ + "04fcfe5f1150fbf476680192b4e367ec.mp4";